import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ModuleLayout from '../../layout/ModuleLayout';
import { useTranslation } from 'react-i18next';
import {
  FaCalculator,
  FaFileAlt,
  FaBalanceScale,
  FaBook,
  FaChartPie
} from 'react-icons/fa';

// Import components
import { ReleveCompte, BalanceComptable, GrandLivre, SyntheseComptable } from '../Comptabilite';

const AccountingModule = () => {
  const { t } = useTranslation();

  const moduleConfig = {
    id: 'accounting',
    title: t('modules.accounting.title'),
    description: t('modules.accounting.description'),
    icon: FaCalculator,
    color: '#6610f2',
    menuItems: [
      { path: '/accounting-module/releve-compte', icon: FaFileAlt, label: 'Relevé de Compte' },
      { path: '/accounting-module/balance', icon: FaBalanceScale, label: 'Balance Comptable' },
      { path: '/accounting-module/grand-livre', icon: FaBook, label: 'Grand Livre' },
      { path: '/accounting-module/synthese', icon: FaChartPie, label: 'Synthèse Comptable' }
    ]
  };

  return (
    <ModuleLayout moduleConfig={moduleConfig}>
      <Routes>
        <Route path="/" element={<Navigate to="/accounting-module/releve-compte" replace />} />
        <Route path="/releve-compte" element={<ReleveCompte />} />
        <Route path="/balance" element={<BalanceComptable />} />
        <Route path="/grand-livre" element={<GrandLivre />} />
        <Route path="/synthese" element={<SyntheseComptable />} />
      </Routes>
    </ModuleLayout>
  );
};

export default AccountingModule;
